import { render, staticRenderFns } from "./CustomUrlLandingPage.vue?vue&type=template&id=1cba40ca"
import script from "./CustomUrlLandingPage.vue?vue&type=script&lang=js"
export * from "./CustomUrlLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports